import { render, staticRenderFns } from "./Index65GameBoy.vue?vue&type=template&id=7bae359c&scoped=true&"
import script from "./Index65GameBoy.vue?vue&type=script&lang=js&"
export * from "./Index65GameBoy.vue?vue&type=script&lang=js&"
import style0 from "./Index65GameBoy.vue?vue&type=style&index=0&id=7bae359c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bae359c",
  null
  
)

export default component.exports